import { AxiosError } from 'axios';
import useSWRMutation from 'swr/mutation';

import { WithStatusT } from '@consumer-frontend/nc-utils';

import {
  apiEndpoints,
  unauthenticatedFetchers,
} from '../lib';

export type SendEmailCodeErrorResponseT = {
  error_type?: string;
};

// Fetcher returns an empty object, but to satisfy unAunthenticatedFetchers typescript, Record<string, number> is used {status: number}
export type SendEmailCodeResponseT = WithStatusT<Record<string, number>>;

export const useSendEmailCode = () => {
  const {
    error,
    isMutating,
    reset,
    trigger: sendEmailCode,
  } = useSWRMutation<
    SendEmailCodeResponseT,
    AxiosError<SendEmailCodeErrorResponseT>,
    string,
    undefined
  >(
    apiEndpoints.apply.v2.sendEmailCode,
    (url, { arg }) => unauthenticatedFetchers.post(url, { arg }),
    { throwOnError: false },
  );

  return {
    error,
    isMutating,
    reset,
    sendEmailCode,
  };
};
